import { HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../components/TableContent';

interface SkeletonItemMobileProps {}

export const SkeletonItemMobile: React.FC<SkeletonItemMobileProps> = () => {
  return (
    <TableContent direction="column" space={Spacing['inline.xxxs']}>
      <HStack justifyContent="space-between" w="full">
        <VStack space={Spacing['stack.quarck']} flex={1}>
          <Skeleton
            w="80%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="50%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>
        <HStack space={Spacing['inline.nano']}>
          <Skeleton
            w={Spacing['inline.xs']}
            h={Spacing['inline.xs']}
            borderRadius={BoxRadius.circular}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w={Spacing['inline.xs']}
            h={Spacing['inline.xs']}
            borderRadius={BoxRadius.circular}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w={Spacing['inline.xs']}
            h={Spacing['inline.xs']}
            borderRadius={BoxRadius.circular}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
      </HStack>
      <VStack space={Spacing['stack.nano']} w="full">
        <HStack space={Spacing['stack.quarck']} flex={1} justifyContent="space-between">
          <Skeleton
            w="30%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="30%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
        <HStack space={Spacing['stack.quarck']} flex={1} justifyContent="space-between">
          <Skeleton
            w="30%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="25%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
        <HStack
          space={Spacing['stack.quarck']}
          alignItems="center"
          flex={1}
          justifyContent="space-between">
          <Skeleton
            w="30%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="40%"
            h={Spacing['inline.xxs']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
      </VStack>
      <HStack
        space={Spacing['stack.quarck']}
        alignItems="center"
        w="full"
        justifyContent="space-between">
        <VStack space={Spacing['stack.nano']} flex={1}>
          <Skeleton
            w="40%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="40%"
            h={Typography['fontsize.xl']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>

        <Skeleton
          w="40px"
          h="40px"
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </HStack>
    </TableContent>
  );
};
